import { CheckBoxButton } from './CheckBoxButton'
import { RadioButton } from './RadioButton'

export const FilterOption = ({
  title = '',
  responseFunction,
  isClicked = false,
  buttonType = 'checkBox'
}) => {
  return (
    <div
      className="mt-lg flex w-full items-center justify-between sm:flex-row-reverse sm:items-start sm:justify-end"
      onClick={responseFunction}
    >
      <div
        id="filter_option_title"
        className="text-base font-normal leading-26 text-[#404040] sm:ml-[15px] sm:w-[106px] sm:break-words"
      >
        {title}
      </div>
      <div id="filter_option_box" className="relative h-fit w-fit sm:mt-[4px]">
        {buttonType == 'checkBox' && (
          <CheckBoxButton
            {...{
              isClicked
            }}
          />
        )}
        {buttonType == 'radio' && <RadioButton {...{ isClicked }} />}
      </div>
    </div>
  )
}
